import CustomComponent from "./customComponent";
import { withRouter } from "./withRouter";
import { withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import { withToast } from "../App";
import logoVNF from "../assets/img/logo-vnf-bleu.svg";
import logoHaropa from "../assets/img/logo-haropa-bleu.svg";
import logoBorneEtEaux from "../assets/img/logo-borne_et_eaux.png";
import logoCofinanceEU from "../assets/img/Cofinance-par-l-Union-europeenne.png";
import logoRIDF from "../assets/img/LOGO_RIDF_2019_COMPACT.svg";
import Cookies from "js-cookie";

class Footer extends CustomComponent {
    replayTour() {
        Cookies.remove("SkipTour");
        window.location.reload();
    }

    render() {
        const { t } = this.props;

        return (
            <footer className="footer">
                <div className="footer__top">
                    <img src={logoBorneEtEaux} alt="logo Borne et Eau" />
                </div>
                <div className="footer__bottom">
                    <div className="footer__bottom__left">
                        <p>{t("A service developped by ...")}</p>
                        <div className="footer__logo-list">
                            <img src={logoVNF} alt="VNF" />
                            <img src={logoHaropa} alt="Haropa" />
                        </div>
                    </div>
                    <div className="footer__bottom__right">
                        <p>{t("with_support_from")}</p>
                        <div className="footer__logo-list">
                            <img
                                src={logoCofinanceEU}
                                height="80"
                                alt="Cofinancé par l'Union Européenne"
                            />
                            <img
                                src={logoRIDF}
                                height="80"
                                alt="Région Île de France"
                            />
                        </div>
                    </div>
                </div>
                {!this.props.disableReplayButton && (
                    <div className="footer__replay-tour">
                        <button onClick={() => this.replayTour()} type="button">
                            {t("replay_tutorial")}
                        </button>
                    </div>
                )}
            </footer>
        );
    }
}

export default withToast(
    hoistStatics(withTranslation()(withRouter(Footer)), Footer),
);
